import { TopRightCorner } from "./userProfileCorner.style";
import { ReactComponent as ArrowDown } from "../../../img/MenuArrowDown.svg";
import Firebase from "../../../services/firebase";
import { useHistory } from "react-router-dom";
import FloatingMenu from "../../utils/FloatingMenu";
import StateContext from "../../../context/StateContext";
import { useContext } from "react";

const UserProfileCorner = ({ mail }) => {
	const { dispatch, ACTIONS } = useContext(StateContext);
	const history = useHistory();
	const logOut = async () => {
		await Firebase.logout();
		dispatch({ type: ACTIONS.RESET_STATE });
		history.push("/login");
	};
	return (
		<TopRightCorner>
			{mail}
			<FloatingMenu rowId="1" rowCode="1" options={[{ label: "Logout", action: logOut }]} icon={<ArrowDown />}></FloatingMenu>
		</TopRightCorner>
	);
};

export default UserProfileCorner;
